(() => {
  const trackEvent = (eventName, details = {}) => {
    try {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: eventName,
          ...details
        });
      }

      if (typeof window.gtag === "function") {
        window.gtag("event", eventName, details);
      }
    } catch (error) {
      // Analytics should never interrupt page functionality.
    }
  };

  const initializeInvestorPage = (root) => {
    if (!root || root.dataset.ederraInitialized === "true") return;

    root.dataset.ederraInitialized = "true";

    root.addEventListener("click", (event) => {
      const trackingElement = event.target.closest("[data-ederra-event]");

      if (!trackingElement) return;

      const eventName = trackingElement.dataset.ederraEvent;

      if (eventName) {
        trackEvent(eventName, {
          location: "investor_page"
        });
      }
    });

    root.querySelectorAll('a[href="#ederra-investor-meeting"]').forEach((link) => {
      link.addEventListener("click", (event) => {
        const meetingSection = document.querySelector(
          "#ederra-investor-meeting"
        );

        if (!meetingSection) return;

        event.preventDefault();

        meetingSection.scrollIntoView({
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
            ? "auto"
            : "smooth",
          block: "start"
        });
      });
    });

    const form = root.querySelector("#EderraInvestorForm");
    const successMessage = root.querySelector(
      "[data-ederra-form-success]"
    );

    if (successMessage) {
      try {
        const pendingSubmission = sessionStorage.getItem(
          "ederraInvestorSubmission"
        );

        if (pendingSubmission) {
          const submissionData = JSON.parse(pendingSubmission);

          trackEvent("investor_form_submit", {
            location: "investor_page",
            investor_type: submissionData.investorType || ""
          });

          sessionStorage.removeItem("ederraInvestorSubmission");
        }
      } catch (error) {
        // Ignore unavailable session storage.
      }

      window.requestAnimationFrame(() => {
        successMessage.focus({
          preventScroll: true
        });

        successMessage.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      });
    }

    if (!form) return;

    form.addEventListener("submit", (event) => {
      const honeypot = form.querySelector("[data-ederra-honeypot]");
      const submitButton = form.querySelector("[data-ederra-submit]");
      const investorType = form.querySelector(
        '[name="contact[Investor type]"]'
      );

      if (honeypot && honeypot.value.trim() !== "") {
        event.preventDefault();
        return;
      }

      if (!form.checkValidity()) {
        return;
      }

      try {
        sessionStorage.setItem(
          "ederraInvestorSubmission",
          JSON.stringify({
            investorType: investorType ? investorType.value : ""
          })
        );
      } catch (error) {
        // Submission can continue without session storage.
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute("aria-busy", "true");
        submitButton.textContent = "Sending…";
      }
    });
  };

  const initializeAllInvestorPages = () => {
    document
      .querySelectorAll(".ederra-investor")
      .forEach(initializeInvestorPage);
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeAllInvestorPages
    );
  } else {
    initializeAllInvestorPages();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const root = event.target.querySelector(".ederra-investor");

    if (root) {
      initializeInvestorPage(root);
    }
  });
})();